import * as React from "react";
import { UitkFullscreenDialog, UitkDialogContent } from "uitk-react-dialog";
import { UitkToolbar } from "uitk-react-toolbar";
import { TripCostEstimatorHotelCost } from "../typings";
import { observer } from "mobx-react";
import { ItemKeyHelper } from "src/components/utility/ItemKeyHelper";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { formatText } from "bernie-l10n";

const prevYear = new Date().getFullYear() - 1;

const l10n = {
  noData: () => formatText("tripCostEstimator.noData"),
  month: () => formatText("tripCostEstimator.month"),
  price: () => formatText("tripCostEstimator.price"),
  footerText: () => formatText("tripCostEstimator.footerDialog", prevYear, "Expedia.com"),
  allPrice: () => formatText("tripCostEstimator.allPrices", "USD")
};

export const ListItem = (props: { text: string; prices: number[]; onClick: () => void }) => {
  const somePriceIsEmpty = props.prices.some(item => !item);
  const pricesRange: string = props.prices.map(item => `$${item}`).join(" - ");
  const Link = () => (
    <TrackedLink
      className="Link"
      onClick={props.onClick}
      moduleName="tripCostEstimator"
      rfrr="dialog.monthList"
    >
      {pricesRange}
    </TrackedLink>
  );

  const contentText = somePriceIsEmpty ? l10n.noData() : <Link />;

  return (
    <tr className="ListItem">
      <td className="uitk-type-300 uitk-type-medium">{props.text}</td>
      <td className="uitk-type-300">{contentText}</td>
    </tr>
  );
};

interface TripCostDialogProps {
  close: () => void;
  hotelCostList: TripCostEstimatorHotelCost[];
  isOpen?: boolean;
  onClickList: (hotelCost?: TripCostEstimatorHotelCost) => void;
  title: string;
}

const TripCostDialogComponent = ({
  close,
  hotelCostList,
  onClickList,
  title
}: TripCostDialogProps) => {
  const keyHelper = new ItemKeyHelper("trip-cost-dialog-list");

  return (
    <UitkFullscreenDialog className="TripCostDialog" dialogShow={true}>
      <UitkToolbar action={close} header={title} iconLabel="Close" className="cleanFlex" />
      <UitkDialogContent className="container">
        <table className="uitk-table">
          <thead className="uitk-table-head">
            <tr>
              <th scope="col" className="uitk-type-400">
                {l10n.month()}
              </th>
              <th scope="col" className="uitk-type-400">
                {l10n.price()}
              </th>
            </tr>
          </thead>
          <tbody className="uitk-table-body">
            {hotelCostList.map((hotelCost: TripCostEstimatorHotelCost) => {
              const handleClick = () => onClickList(hotelCost);
              const { avgTwoStarsCost, avgFourStarsCost, month: label } = hotelCost;

              return (
                <ListItem
                  text={label}
                  prices={[avgTwoStarsCost, avgFourStarsCost]}
                  key={keyHelper.next()}
                  onClick={handleClick}
                />
              );
            })}
          </tbody>
        </table>
        <p className="uitk-type-200">{l10n.footerText()}</p>
        <p className="uitk-type-200">{l10n.allPrice()}</p>
      </UitkDialogContent>
    </UitkFullscreenDialog>
  );
};

export const TripCostDialog = observer(TripCostDialogComponent);

export default TripCostDialog;
